import type {FC} from 'react';
import type {SxProps} from '@mui/material';
import {Select} from '@wellstone-solutions/web';
import {states} from 'utils/Forms';

type PropsType = {
  onChange: (value: string) => void;
  value?: string;
  sx?: SxProps;
};

export const SelectState: FC<PropsType> = ({
  onChange,
  value,
  sx = {
    backgroundColor: '#fff',
    height: '100%',
    borderRadius: 2,
  },
  ...rest
}: PropsType) => {
  const items = states.map((state) => ({
    label: state,
    value: state,
  }));

  items.unshift({
    label: 'State',
    value: '',
  });

  const augmentedValue = value ?? items[0].value;

  return (
    <Select
      fullWidth
      {...rest}
      items={items}
      onChange={onChange}
      value={augmentedValue}
      inputProps={{
        sx,
      }}
      label="State"
    />
  );
};
